import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export function exportPDF(selector) {
  const pdf = new jsPDF('portrait', 'mm', 'a4')
  const a4 = {width: 210, height: 297}
  const scale = 2

  const element = document.getElementsByClassName(selector)[0]

  const monochrome = (original) => {
    const canvas = document.createElement('canvas')
          canvas.setAttribute('width', original.width)
          canvas.setAttribute('height', original.height)
    const context = canvas.getContext('2d')
          context.drawImage(original, 0, 0)
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
    const { data } = imageData

    // invert
    for (let i = 0; i < data.length; i += 4) {
      data[i]   = 255 - data[i]   // red
      data[i+1] = 255 - data[i+1] // green
      data[i+2] = 255 - data[i+2] // blue
    }
    context.putImageData(imageData, 0, 0)

    // grayscale
    for (let i = 0; i < data.length; i += 4) {
      var avg = (data[i] + data[i + 1] + data[i + 2]) / 3
      data[i]   = avg // red
      data[i+1] = avg // green
      data[i+2] = avg // blue
    }
    context.putImageData(imageData, 0, 0)

    return canvas
  }

  return html2canvas(element, {backgroundColor: '#000000', logging: false, scale})
  .then(canvas => {
    canvas = monochrome(canvas)

    const documentWidth = canvas.width/scale
    const documentHeight = canvas.height/scale

    const ratio = documentWidth/a4.width
    const height = documentHeight/ratio

    const pageBreaks = document.getElementsByClassName('page-break')

    if (pageBreaks.length > 0) {
      for (let i = 0; i <= pageBreaks.length; i++) {
        const offsetTop = (i > 0) ? pageBreaks[i-1].offsetTop/ratio : 0
        const nextOffset = pageBreaks[i] ? pageBreaks[i].offsetTop/ratio : undefined
        const elementHeight = nextOffset ? nextOffset-offsetTop : undefined

        if (i > 0) pdf.addPage(a4.width, a4.height)

        pdf.setPage(i+1)
        pdf.setFillColor('#ffffff')
        if (elementHeight === undefined) pdf.rect(0, 0, a4.width, a4.height, 'F')
        pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 0, -(offsetTop), a4.width, height)
        if (elementHeight) pdf.rect(0, elementHeight, a4.width, a4.height-elementHeight, 'F')
      }
    } else {
      for (let i = 0; i < height/a4.height; i++) {
        const offsetTop = i*a4.height

        if (i > 0) pdf.addPage(a4.width, a4.height)

        pdf.setPage(i+1)
        pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 0, (i > 0 ? -(offsetTop) : 0), a4.width, height)
      }
    }

    pdf.save('test.pdf')

    return {
      status: 'success',
      data: {
        title: 'test.pdf'
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/export.js